module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "noMargin"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "pageTitle"
  }, [_c('h2', [_vm._v("DISCOUNT REQUEST REPORTS")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncFilterDiscount()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("filter_list")]), _vm._v("FILTER / CUSTOMIZE REPORT")]), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncExportDiscount()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")]), _vm._v("EXPORT TO CSV")]), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncReloadDiscount.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons reloadButton"
  }, [_vm._v("refresh")])])], 1)], 1)], 1)
},staticRenderFns: []}